import React from "react";
import { Image } from "@sitecore-jss/sitecore-jss-react";
import { scImageType, scLinkType, scStringType } from "../../types";

var PausedAccountModule = function PausedAccountModule(props) {
  var _ContactUsButton$valu, _ContactUsButton$valu2;

  var _ref = (props === null || props === void 0 ? void 0 : props.model) || {},
      BackgroundGIF = _ref.BackgroundGIF,
      Title = _ref.Title,
      SubTitle = _ref.SubTitle,
      Header = _ref.Header,
      Copy = _ref.Copy,
      ContactUsButton = _ref.ContactUsButton;

  return /*#__PURE__*/React.createElement("div", {
    className: "paused-account-modal"
  }, /*#__PURE__*/React.createElement("div", {
    className: "paused-account-modal__top"
  }, /*#__PURE__*/React.createElement(Image, {
    field: BackgroundGIF
  }), /*#__PURE__*/React.createElement("span", {
    className: "paused-account-modal__title"
  }, Title === null || Title === void 0 ? void 0 : Title.value), /*#__PURE__*/React.createElement("span", {
    className: "paused-account-modal__subtitle"
  }, SubTitle === null || SubTitle === void 0 ? void 0 : SubTitle.value)), /*#__PURE__*/React.createElement("div", {
    className: "paused-account-modal__body"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "paused-account-modal__header"
  }, Header === null || Header === void 0 ? void 0 : Header.value), /*#__PURE__*/React.createElement("div", {
    className: "paused-account-modal__copy",
    dangerouslySetInnerHTML: {
      __html: Copy === null || Copy === void 0 ? void 0 : Copy.value
    }
  }), /*#__PURE__*/React.createElement("a", {
    href: ContactUsButton === null || ContactUsButton === void 0 ? void 0 : (_ContactUsButton$valu = ContactUsButton.value) === null || _ContactUsButton$valu === void 0 ? void 0 : _ContactUsButton$valu.href,
    className: "cb-button-primary paused-account-modal__cta"
  }, ContactUsButton === null || ContactUsButton === void 0 ? void 0 : (_ContactUsButton$valu2 = ContactUsButton.value) === null || _ContactUsButton$valu2 === void 0 ? void 0 : _ContactUsButton$valu2.text)));
};

export default PausedAccountModule;